import {type FC, memo, type PropsWithChildren, useRef} from 'react';
import type {ScrollbarProps} from 'react-scrollbars-custom';
import Scrollbar from 'react-scrollbars-custom';

import classNames from 'classnames';

import styles from './List.module.css';

interface Props extends ScrollbarProps {
  customScrollbar?: boolean;
}

const List: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  customScrollbar,
  ...rest
}) => {
  const scrollbarProps = useRef<ScrollbarProps>({
    thumbXProps: {},
    thumbYProps: {},
    trackXProps: {style: {height: 4}},
    trackYProps: {
      style: {
        width: 4,
      },
    },
    wrapperProps: {
      style: {
        inset: '0 10px 0 0',
      },
    },
  }).current;

  return customScrollbar ? (
    // @ts-expect-error: invalid props
    <Scrollbar {...scrollbarProps} {...rest}>
      <ul className={classNames(styles.List, className)}>{children}</ul>
    </Scrollbar>
  ) : (
    <ul className={classNames(styles.List, className)}>{children}</ul>
  );
};

export default memo(List);
